import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-college-application-view',
  templateUrl: './college-application-view.component.html',
  styleUrls: ['./college-application-view.component.scss']
})
export class CollegeApplicationViewComponent implements OnInit {
  applicationId: string;
  application: any = {};
  isLoading = true;
  errorMessage = '';
  courses: any[] = [];
  cities: any[] = [];
  colleges: any[] = [];
  entranceExams: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.applicationId = this.route.snapshot.paramMap.get('id');
    this.loadApplicationData();
    this.loadDropdownData();
  }

  loadApplicationData(): void {
    this.http.get<any>(`${environment.apiUrl}/collegeapplication/${this.applicationId}`)
      .subscribe(
        (data) => {
          this.application = data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.errorMessage = 'Failed to load application data. Please try again later.';
          this.isLoading = false;
          console.error('Error loading application:', error);
        }
      );
  }

  loadDropdownData(): void {
    // Load courses
    this.http.get<any>(`${environment.apiUrl}/course/`)
      .subscribe(
        (data) => {
          this.courses = data.results || data;
        },
        (error) => {
          console.error('Error loading courses:', error);
        }
      );

    // Load cities
    this.http.get<any>(`${environment.apiUrl}/city/`)
      .subscribe(
        (data) => {
          this.cities = data.results || data;
        },
        (error) => {
          console.error('Error loading cities:', error);
        }
      );

    // Load colleges
    this.http.get<any>(`${environment.apiUrl}/college/`)
      .subscribe(
        (data) => {
          this.colleges = data.results || data;
        },
        (error) => {
          console.error('Error loading colleges:', error);
        }
      );

    // Load entrance exams
    this.http.get<any>(`${environment.apiUrl}/collegeentranceexamdetails/`)
      .subscribe(
        (data) => {
          this.entranceExams = data.results || data;
        },
        (error) => {
          console.error('Error loading entrance exams:', error);
        }
      );
  }

  getCourseName(id: string): string {
    const course = this.courses.find(c => c._id === id);
    return course ? course.name : 'Unknown Course';
  }

  getCityName(id: string): string {
    const city = this.cities.find(c => c._id === id);
    return city ? city.name : 'Unknown City';
  }

  getCollegeName(id: string): string {
    const college = this.colleges.find(c => c._id === id);
    return college ? college.name : 'Unknown College';
  }

  getExamName(id: string): string {
    const exam = this.entranceExams.find(e => e._id === id);
    return exam ? exam.name : 'Unknown Exam';
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'Selected': return 'badge bg-success';
      case 'Rejected': return 'badge bg-danger';
      case 'In Review': return 'badge bg-info';
      default: return 'badge bg-secondary';
    }
  }

  getCollegeStatusBadgeClass(status: string): string {
    switch (status) {
      case 'Admitted': return 'badge bg-success';
      case 'Rejected': return 'badge bg-danger';
      case 'Shortlisted': return 'badge bg-warning text-dark';
      case 'Applied': return 'badge bg-info';
      default: return 'badge bg-secondary';
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  goBack(): void {
    this.router.navigate(['/college-details/college-application-list']);
  }
}